<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <ion-list class="disable-background-color">
    <ion-item class="disable-background-color">
      <ion-icon name="at" item-left></ion-icon>
      <ion-input formControlName="email" type="email" [placeholder]="'Auth.Email' | translate" (ngModelChange)="alreadyInUse = false"></ion-input>
    </ion-item>
  </ion-list>

  <div>
    <ion-button expand="block" type="submit" [disabled]="!form.valid">{{ 'General.Next' | translate }}</ion-button>
  </div>

  <div style="padding: 10px;" [hidden]="!alreadyInUse">
    <p class="text-center notice-text" [innerHTML]="'Auth.EmailInUseMessage' | translate: { email: form.get('email').value }">
    </p>
    @if (!fromDesktopCheckout) {
      <ion-button expand="block" color="primary" (click)="goToLogin()">{{ 'Auth.ClickHereToLoginInsteadMessage' | translate }}</ion-button>
    }
  </div>
</form>